import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { spLogTags } from "@eventr/common";

export const setStatusBarStyleLight = async () => {
  if (!Capacitor.isNativePlatform()) return;
  const info = await StatusBar.getInfo();
  if (info.style === Style.Light) return;
  spLogTags("setStatusBarStyleLight", ["UX"]);
  await StatusBar.setStyle({ style: Style.Light });
};
export const setStatusBarStyleDark = async () => {
  if (!Capacitor.isNativePlatform()) return;
  const info = await StatusBar.getInfo();
  if (info.style === Style.Dark) return;
  spLogTags("setStatusBarStyleDark", ["UX"]);
  await StatusBar.setStyle({ style: Style.Dark });
};

/**
 * Dark status bar text while a light screen is up, the previous style back when it goes. A
 * screen pushed over a picture header (a chat room over the Chat tab's) otherwise keeps the
 * header's light text, white on white. Returns the release, for an effect's cleanup.
 */
export const holdDarkStatusBarText = (): (() => void) => {
  let previous: Style | undefined;
  let released = false;
  if (Capacitor.isNativePlatform()) {
    void StatusBar.getInfo().then(async (info) => {
      if (released) return;
      previous = info.style;
      // `Style.Light` is the style for a light background: dark text.
      if (info.style !== Style.Light) await StatusBar.setStyle({ style: Style.Light });
    });
  }
  return () => {
    released = true;
    if (previous && previous !== Style.Light) void StatusBar.setStyle({ style: previous });
  };
};
